import React, {useState} from 'react';

import Webcam from "react-webcam";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import "./PortraitCapture.css";
import {IconButton, Stack, Typography} from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';
import {FormattedMessage, useIntl} from "react-intl";
import {FileApi} from "../../../../../modules/ftp/api/FileApi";
import {HttpStatus} from "../../../../../modules/common/enums/HttpStatus";
import LoadingBackdrop from "../../../../../components/LoadingBackdrop";

export type ConstructionCaptureProps = {
    onPrevious: () => void;
    onNext: (fileId: string) => void;
    title: string;
};

const AttachFileCapture: React.FC<ConstructionCaptureProps> = (props) => {
    const intl = useIntl();
    const webcamRef = React.useRef<Webcam>(null);

    const [portrait, setPortrait] = useState('');
    const [loading, setLoading] = useState(false);

    const handlePrevious = () => {
        props.onPrevious();
    }

    const handleNext = () => {
        props.onNext(portrait);
    }

    const handleCancel = () => {
        setPortrait('');
    }

    const handleOk = () => {
        if (portrait) {
            handleUploadFile();
        }
    }

    const handleUploadFile = async () => {
        setLoading(true);
        const responseResult = await FileApi.uploadBase64File(portrait);
        if (responseResult.status === HttpStatus.SUCCESS) {
            props.onNext(responseResult.data);
        }
        setLoading(false);
    }

    const handleCapture = React.useCallback(
        () => {
            const imageSrc = webcamRef?.current?.getScreenshot();
            setPortrait(imageSrc || "");
        },
        [webcamRef]
    );

    const renderWebCam = () => {
        return (
            <div className="portrait">
                <LoadingBackdrop open={loading} onClick={() => setLoading(false)}/>
                <Webcam audio={false} ref={webcamRef} screenshotFormat="image/jpeg"/>

                <div className="background">
                    <div className="layer">
                        <IconButton className="btn-capture" onClick={handlePrevious}>
                            <ArrowBackIosIcon fontSize="large"/>
                        </IconButton>
                        <IconButton className="btn-capture" onClick={handleCapture}>
                            <PhotoCameraIcon fontSize="large"/>
                        </IconButton>
                        <IconButton className="btn-capture" onClick={handleNext}>
                            <ArrowForwardIosIcon fontSize="large"/>
                        </IconButton>
                    </div>
                </div>
            </div>
        );
    }

    const renderWebCamScreenShot = () => {
        return (
            <div className="portrait">
                {portrait ? <img src={portrait}/> : null}

                <div className="layer">
                    <IconButton className="btn-capture" onClick={handleCancel}>
                        <CancelIcon fontSize="large"/>
                    </IconButton>
                    <IconButton className="btn-capture" onClick={handleOk}>
                        <CheckIcon fontSize="large"/>
                    </IconButton>
                </div>
            </div>
        )
    }

    return (
        <div className="self-terminal-form">
            <div style={{textAlign: 'center'}}>
                <Typography variant="h4" gutterBottom>
                    {props.title}
                </Typography>
            </div>
            <div>
                {
                    portrait ? renderWebCamScreenShot() : renderWebCam()
                }
            </div>
        </div>
    );
}

export default AttachFileCapture;